import React, { useState } from "react";
import { useDispatch } from "react-redux";

import ChevronDown from "../../UI/ChevronDown";
import AlertCircle from "../../UI/AlertCircle";
import CheckCircle from "../../UI/CheckCircle";
import LetterX from "../../UI/LetterX";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";

import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";

import {
  getPrescriptores,
  postPrescriptor,
} from "../../../../actions/autorizaciones/Autorizaciones";
import { AUTORIZACIONES_PRACTICAS_ESTADOS } from "../../../../utils/constants";

export const AutorizacionesAccordionPrescriptor = (props) => {
  const disptach = useDispatch();

  const [apellidoNroMatricula, setApellidoNroMatricula] = useState("");
  const [prescriptores, setPrescriptores] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [nombreApellido, setNombreApellido] = useState("");
  const [matriculaNac, setMatriculaNac] = useState("");
  const [matriculaProv, setMatriculaProv] = useState("");
  const [prescriptorSeleccionado, setPrescriptorSeleccionado] = useState(
    props.prePrescriptor
  );

  const onSubmitModalHandler = () => {
    const prescriptor = {
      nombre: nombreApellido,
      matnacional: matriculaNac,
      matprovincial: matriculaProv,
    };

    disptach(
      postPrescriptor(apellidoNroMatricula, prescriptor, setPrescriptores)
    );
    setOpenModal(false);
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();

    if (prescriptores?.length === 0) {
      disptach(getPrescriptores(apellidoNroMatricula, setPrescriptores));
    } else {
      setApellidoNroMatricula("");
      setPrescriptores([]);
      props.setearEfector(null);
    }
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth
        maxWidth="sm"
        open={openModal}
        onClose={() => {
          setOpenModal(false);
        }}
      >
        <DialogTitle>Agregar Prescriptor</DialogTitle>
        <DialogContent>
          <ValidatorForm
            onSubmit={onSubmitModalHandler}
            style={{ flexGrow: "1", margin: "1rem" }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextValidator
                  fullWidth
                  label="Nombre y Apellido"
                  name="nombreApellido"
                  value={nombreApellido}
                  onChange={(e) => setNombreApellido(e.target.value)}
                  validators={["required"]}
                  errorMessages={["El nombre y apellido es requerido"]}
                />
              </Grid>
              <Grid item xs={6}>
                <TextValidator
                  fullWidth
                  label="Matricula Nac."
                  name="matriculaNac"
                  value={matriculaNac}
                  onChange={(e) => setMatriculaNac(e.target.value)}
                />
              </Grid>
              <Grid item xs={6}>
                <TextValidator
                  fullWidth
                  label="Matricula Prov."
                  name="matriculaProv"
                  value={matriculaProv}
                  onChange={(e) => setMatriculaProv(e.target.value)}
                />
              </Grid>
              <Grid
                item
                style={{
                  display: "flex",
                  justifyContent: "right",
                  marginTop: "2.5rem",
                  flexGrow: "1",
                }}
              >
                <Button
                  style={{ marginRight: "1rem" }}
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    setOpenModal(false);
                  }}
                >
                  Cerrar
                </Button>
                <Button variant="contained" color="primary" type="submit">
                  Confirmar
                </Button>
              </Grid>
            </Grid>
          </ValidatorForm>
        </DialogContent>
      </Dialog>
      <Accordion TransitionProps={{ unmountOnExit: true }} style={{ marginLeft: 45 }}>
        <AccordionSummary expandIcon={<ChevronDown />}>
          <Typography variant="h6">
            Prescriptor
            {props.estaCorrecto ? <CheckCircle /> : <AlertCircle />}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {!!prescriptorSeleccionado ? (
            <Grid container spacing={1} style={{ marginTop: "1.5rem" }}>
              <div
                style={{
                  padding: "1rem",
                  marginBottom: "0.5rem",
                  marginRight: "1rem",
                  marginLeft: "1rem",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                {!props.esDenunciaInternacion && !props.disabled 
                && (props.practica?.idEstadoPractica === AUTORIZACIONES_PRACTICAS_ESTADOS.PENDIENTE
                  || props.practica?.idEstadoPractica === AUTORIZACIONES_PRACTICAS_ESTADOS.GESTION)
                 && (
                  <LetterX
                    deleteFunction={() => {
                      props.setearEfector(null);
                      setPrescriptorSeleccionado(null);
                    }}
                    styles={{
                      cursor: "pointer",
                      position: "relative",
                      top: "0.15rem",
                      marginRight: "0.5rem",
                    }}
                  />
                )}
                <Typography
                  variant="h6"
                  style={{ flexGrow: 1, fontSize: "1rem", fontStyle: "italic" }}
                >
                  {prescriptorSeleccionado?.nombre}
                </Typography>
              </div>
            </Grid>
          ) : (
            <ValidatorForm
              style={{ flexGrow: "1", margin: "1rem" }}
              onSubmit={onSubmitHandler}
            >
              {prescriptores?.length === 0 && !props.disabled && (
                <Grid container>
                  <Grid item xs={1} sm={1} md={2} lg={3}></Grid>
                  <Grid item xs={10} sm={10} md={8} lg={6}>
                    <TextValidator
                      fullWidth
                      label="Nro Matricula / Apellido"
                      name="apellidoNroMatricula"
                      value={apellidoNroMatricula}
                      // disabled={props.esDenunciaInternacion}
                      onChange={(e) => setApellidoNroMatricula(e.target.value)}
                      validators={["required"]}
                      errorMessages={["Este campo es requerido"]}
                    />
                  </Grid>
                  <Grid item xs={1} sm={1} md={2} lg={3}></Grid>
                </Grid>
              )}
              {!props.disabled &&
                <Grid
                  item
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "1.5rem",
                    flexGrow: "1",
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    disabled={props.practica?.idEstadoPractica !== AUTORIZACIONES_PRACTICAS_ESTADOS.PENDIENTE
                      && props.practica?.idEstadoPractica !== AUTORIZACIONES_PRACTICAS_ESTADOS.GESTION}
                  >
                    {prescriptores?.length === 0
                      ? "Consultar"
                      : "Volver a consultar"}
                  </Button>
                </Grid>
              }
              {Array.isArray(prescriptores) && prescriptores?.length > 0 && (
                <Grid item xs={12} style={{ marginTop: "1rem" }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell style={{ width: "8%" }}></TableCell>
                        <TableCell style={{ width: "62%" }}>
                          Apellido y Nombre
                        </TableCell>
                        <TableCell style={{ width: "15%" }}>
                          Matricula Nac.
                        </TableCell>
                        <TableCell style={{ width: "15%" }}>
                          Matricula Prov.
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {prescriptores.map((prescriptor, index) => {
                        return (
                          <TableRow key={index}>
                            <TableCell>
                              <Checkbox
                                onChange={() => {
                                  props.setearEfector(
                                    prescriptor.idPrescriptor
                                  );
                                  setPrescriptorSeleccionado(prescriptor);
                                }}
                              />
                            </TableCell>
                            <TableCell>{prescriptor.nombre}</TableCell>
                            <TableCell>{prescriptor.matnacional}</TableCell>
                            <TableCell>{prescriptor.matprovincial}</TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </Grid>
              )}
              {/* {!props.esDenunciaInternacion && !props.disabled && ( */}
              {!props.disabled && (
                <Grid
                  item
                  style={{
                    display: "flex",
                    justifyContent: "right",
                    marginTop: "2rem",
                    flexGrow: "1",
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      setOpenModal(true);
                    }}
                    disabled={props.practica?.idEstadoPractica !== AUTORIZACIONES_PRACTICAS_ESTADOS.PENDIENTE
                      && props.practica?.idEstadoPractica !== AUTORIZACIONES_PRACTICAS_ESTADOS.GESTION}
                  >
                    + Agregar Prescriptor
                  </Button>
                </Grid>
              )}
            </ValidatorForm>
          )}
        </AccordionDetails>
      </Accordion>
    </React.Fragment>
  );
};
